import React from 'react';

import HttpService from 'service/HttpService';

import {A} from 'views/AppElements';
import useReduceStore from 'hooks/ReduceStoreHook';
import {userStoreInfo} from 'hooks/UserHook';
import {useStoresAndInfluencers} from 'hooks/UserHook';
import ProductStore from 'stores/ProductStore';

import UserAvatar from 'views/user/UserAvatar';

import StoreList from 'views/designer/StoreList';

import {Separator} from 'views/AppElements';
import HeaderBanner from 'views/HeaderBanner';
import SetoCanvasPage from 'pages/SetoCanvasPage';

import Loader from 'views/Loader';

import ProductList from 'views/product/ProductList';
import ProductTabs from 'views/product/ProductTabsByType';
import SessionStore from 'stores/SessionStore';
import AppUtil from 'AppUtil';


function getBannerImages(storeInfo) {
	if(!storeInfo || !storeInfo.bannerImages)
		return null;

	const bannerImages = storeInfo.bannerImages.map(i => {
								return {"img": i, "title": storeInfo.storeName+" - Merchandise"}
							});
	return bannerImages;
}


const StorePendingMsg = () => {

	return <div style={{padding: '2px 10px', fontSize: '120%', fontWeight: 'bold', 
					textAlign: 'center', margin: '10px 0', background: '#f8931b', color: 'white'}}>
				Your account is pending approval! Our moderator will review and get back to you as soon as possible.
		</div>
}

const StoreAvatar = ({user}) => {
	const currentSession = SessionStore.getCurrentSession();
	const isCurrentUser = currentSession && user && currentSession.user.id === user.id;
	
	const isCurrentAdmin = AppUtil.isAdminUser(currentSession? currentSession.user: null);
	const isAdmin = AppUtil.isAdminUser(user);

	let editUrl = null;
	if(isCurrentAdmin && !isAdmin && user !== null) editUrl = "/"+user.id+"/settings";
	else editUrl = "/settings";
	
	const editIcon = (isCurrentUser || isCurrentAdmin)? <A href={editUrl} id="userEditIcon"><i className="fa fa-pencil-square-o" aria-hidden="true"></i></A>: null;
	const dashboardIcon = (user !== null && isCurrentAdmin)? <a href={"/designer/"+user.id+"/dashboard"} id="userDashboardIcon"><i className="fa fa-dashboard" aria-hidden="true"></i></a>: null;

	const storeTitle = user? <h2 className="userTitle">{user.storeName.toUpperCase()} {editIcon} {dashboardIcon}</h2>: <Loader className="userTitleLoader" />
	const storeBio = user? <span className="userBio">{user.about}</span>: <Loader className="userBioLoader" />;
	return <div className="storeAvatar flexRow">
			<UserAvatar user={user} />
			<div className="storeBio flexColumn">
				{storeTitle}
				{storeBio}
			</div>
			
	</div>
};

const StorePage = (props) => {
	let storeName = props.match.params.storeName.replace(/-/g, " ");
	if(storeName === 'MMA Merch Nepal') storeName = "MMA Fan Nepal";

	const storeProducts = useReduceStore(ProductStore, (store) => store.getStoreProducts(storeName), 
								() => HttpService.getStoreProducts(storeName), [storeName]);

	const storeInfo = userStoreInfo(storeName);
	const bannerImages = getBannerImages(storeInfo);

	const currentSession = SessionStore.getCurrentSession();
	const currentUser = currentSession? currentSession.user: null;
	let popularStores = useStoresAndInfluencers();
	popularStores = popularStores? popularStores.filter(s => s.storeName && s.storeName !== storeName): null;

	const isAuthorized = storeInfo && currentUser && storeInfo.id === currentUser.id && storeInfo.userStatus === "PENDING_APPROVAL";
	return (
		<SetoCanvasPage title={storeName.toUpperCase() +" Merchandise | Seto Canvas"} 
						metaDescription={"Purchase "+storeName+" merchandise and many more at SetoCanvas.com"}>

			{isAuthorized && <StorePendingMsg />}
			<HeaderBanner bannerImages={bannerImages} title={storeName} />
			<StoreAvatar user={storeInfo} />

			{storeProducts && storeProducts.length > 20 &&
				<ProductTabs products={storeProducts} 
					ownerName={storeName} />
			}
			
			{(!storeProducts || storeProducts.length <= 20) &&
				<ProductList products={storeProducts} viewProductTags={true} flattenProductImages={true}
					productViewMode="productOnly" emptyMsg="No Products Found" />
			}
			<Separator />

			<StoreList stores={popularStores} title="More Stores" appendViewAll={true} />
		</SetoCanvasPage>
	);
}

export default StorePage;




// WEBPACK FOOTER //
// ./src/pages/StorePage.js